import { coordinates, weatherRequest } from "./weatherRequest.js";

export default function weatherFeed({ app, view, model, value, apiKey, fetch, timers = globalThis }) {
  let point = model.fromPoint ? coordinates(value) : undefined;
  let cached;
  let cachedPoint;
  let fetchedAt = 0;
  let pending;
  let pendingPoint;
  let controller;
  let disposed = false;
  const interval = Math.max(1, Number(model.interval) || 60) * 1000;
  const weatherUpdate = async (query = {}) => {
    const key = point?.join(",");
    if (!key) return { ...query, weatherData: undefined, weatherError: "Waiting for location." };
    if (!query.force && cachedPoint === key && Date.now() - fetchedAt < interval)
      return { ...query, weatherData: cached, weatherError: undefined };
    if (!pending || pendingPoint !== key) {
      controller?.abort();
      controller = new AbortController();
      const request = controller;
      const timeout = timers.setTimeout(() => request.abort(), 20000);
      pendingPoint = key;
      const task = weatherRequest({ point, apiKey, fetch, signal: request.signal })
        .then(data => {
          if (disposed || controller !== request || point?.join(",") !== key) return {};
          cached = data; cachedPoint = key; fetchedAt = Date.now();
          return { weatherData: data, weatherError: undefined };
        })
        .catch(error => controller !== request || disposed || point?.join(",") !== key ? {}
          : { weatherData: undefined, weatherError: error.name === "AbortError" ? "Weather request timed out." : error.message })
        .finally(() => { timers.clearTimeout(timeout); if (pending === task) pending = undefined; });
      pending = task;
    }
    return { ...query, ...await pending };
  };
  const refresh = (query) => { if (!disposed) return view.event("weatherUpdate", query).catch(() => {}); };
  const setPoint = value => {
    const next = coordinates(value);
    if (next?.join(",") === point?.join(",")) return;
    point = next;
    if (!point) {
      controller?.abort();
      controller = undefined;
      pending = undefined;
      pendingPoint = undefined;
    }
    refresh();
  };
  const position = ({ longitude, latitude, error }) => {
    if (!error) setPoint([longitude, latitude]);
  };
  const change = ({ id, value }) => {
    if (id && id !== model.id) return;
    setPoint(value?.[model.id] ?? value);
  };
  view.on("weatherUpdate", 1000, weatherUpdate);
  if (model.fromPoint) view.on("change", change);
  else { app.on("mapsDevicePos", position); app.event("mapsDevicePos"); }
  const timer = timers.setInterval(() => refresh({ force: true }), interval);
  refresh();
  return {
    setPoint,
    destroy() {
      disposed = true;
      controller?.abort();
      timers.clearInterval(timer);
      view.off("weatherUpdate", weatherUpdate);
      if (model.fromPoint) view.off("change", change);
      else app.off("mapsDevicePos", position);
    },
  };
}
